import { useResolvedAdvancedSearchItems } from '../../../../ui/features/accounts/hooks/useResolvedAdvancedSearchItems';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import React from 'react';
import { useAccountFilterConfig } from './useAccountsFilterConfig';
/**
 * Resolves account filter customizations and will return not just Contact management but also customized filters.
 * Use this hook if you have entity that references account and want to display account filter in that table.
 */
export function useResolvedAccountFilterConfig(params) {
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const advancedSearchItems = useResolvedAdvancedSearchItems();
    return useAccountFilterConfig(Object.assign(Object.assign({}, params), { extendFilters: accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.extendFilters, advancedSearchItems: advancedSearchItems }));
}
